export const parseImages = (imageUrl) => {
  if (!imageUrl) return {};
  try {
    const parsed = JSON.parse(imageUrl);
    if (typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
  } catch {}
  // Legacy plain URL — treat as primary
  return { '1': imageUrl };
};

export const getPrimaryImage = (imageUrl) => {
  if (!imageUrl) return null;
  const images = parseImages(imageUrl);
  return images['1'] || Object.values(images)[0] || null;
};

export const getImagesArray = (imageUrl) => {
  const images = parseImages(imageUrl);
  return ['1', '2', '3']
    .filter(k => images[k])
    .map(k => ({ key: k, url: images[k] }));
};

export const serializeImages = (imagesObj) => {
  if (!imagesObj || Object.keys(imagesObj).length === 0) return '';
  return JSON.stringify(imagesObj);
};
